import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/joy/Box';
import Table from '@mui/joy/Table';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import Checkbox from '@mui/joy/Checkbox';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import IconButton from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Tooltip from '@mui/joy/Tooltip';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { visuallyHidden } from '@mui/utils';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import LinearProgress from '@mui/material/LinearProgress';



////////////////// Pagintion
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

///////////// Date Formate
import dateFormat, { masks } from "dateformat";
import dayjs from 'dayjs';




/////////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';




///////////////////////// API
import { getUsers, deleteUsers, getUsersByFilter } from '../../Api/Users';



function createData(name, email, subscriptions, created_at, orders_count, actions) {
  return {
    name,
    email,
    subscriptions,
    created_at,
    orders_count,
    actions
  };
}


function labelDisplayedRows({ from, to, count }) {
  return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'اسم العميل',
  },
  {
    id: 'email',
    numeric: true,
    disablePadding: true,
    label: 'البريد الالكتروني',
  },
  {
    id: 'subscriptions',
    numeric: true,
    disablePadding: false,
    label: 'الاشتراك',
  },
  {
    id: 'created_at',
    numeric: true,
    disablePadding: false,
    label: 'تاريخ التسجيل',
  },
  {
    id: 'orders_count',
    numeric: true,
    disablePadding: false,
    label: 'عدد عمليات التقييم',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'الاجراءات',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <thead>
      <tr style={
        { 'background': '#F3F3F3', 'color': '#7C7C7C', fontWeight: 'bold' }
      }>
        {/* <th>
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            slotProps={{
              input: {
                'aria-label': 'select all desserts',
              },
            }}
            sx={{ verticalAlign: 'sub', direction: 'ltr' }}
          />
        </th> */}
        {headCells.map((headCell) => {
          const active = orderBy === headCell.id;
          return (
            <th
              key={headCell.id}
              aria-sort={
                active ? { asc: 'ascending', desc: 'descending' }[order] : undefined
              }
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                underline="none"
                color="neutral"
                textColor={active ? 'primary.plainColor' : undefined}
                component="button"
                onClick={createSortHandler(headCell.id)}
                fontWeight="lg"
                startDecorator={
                  headCell.numeric ? (
                    <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                  ) : null
                }
                endDecorator={
                  !headCell.numeric ? (
                    <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                  ) : null
                }
                sx={{
                  '& svg': {
                    transition: '0.2s',
                    transform:
                      active && order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                  },
                  '&:hover': { '& svg': { opacity: 1 } },
                }}
              >
                {headCell.label}
                {active ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Link>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1,
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: 'background.level1',
        }),
        borderTopLeftRadius: 'var(--unstable_actionRadius)',
        borderTopRightRadius: 'var(--unstable_actionRadius)',
      }}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: '1 1 100%' }} component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          level="body-lg"
          sx={{ flex: '1 1 100%' }}
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton size="sm" color="danger" variant="solid">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : false}
    </Box>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function TableSortAndSelection({
  startDate,
  endDate,
  filterAction
}) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([]);
  const [clientId, setClientId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countPage, setCountPage] = useState(0)
  const [loadingData, setLoadingData] = React.useState(false)

  const [currentPage, setCurrentPage] = React.useState(1);


  let objPagination = {
    page: 1,
  }

  let objFilter = {
    type: 2,
    startDate: startDate,
    endDate: endDate
  }

  const [openAlert, setOpenAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');

  const [openAlertError, setOpenAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState('');

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const handleCloseAlertError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlertError(false);
  };

  const handleChangePagePagintion = async (e, newValuePage) => {
    objPagination.page = newValuePage
    setCurrentPage(newValuePage)
    listUsersByFilter()
  }


  const listUsersData = async () => {
    setLoadingData(true)
    const res = await getUsers('2', objPagination)
    if (res.data) {
      setLoadingData(false)
      setRows(res.data)
      setCountPage(res.last_page)
      setCurrentPage(res.current_page)

    }
  }

  const listUsersByFilter = async () => {
    if (objFilter.startDate == null && objFilter.endDate == null) {
      listUsersData()
    } else {
      setLoadingData(true)
      const res = await getUsersByFilter(objFilter, objPagination)
      if (res.data) {
        console.log("res.data > ", res.data)
        setLoadingData(false)
        setRows(res.data)
        setCountPage(res.last_page)
        setCurrentPage(res.current_page)
      }

    }
  }


  const removeClient = (e, id) => {
    e.preventDefault();
    setClientId(id)
    setOpenModal(true)
  }

  const confirmRemoveClient = async () => {
    setLoading(true)
    try {
      const res = await deleteUsers(clientId)
      if (res) {
        setOpenAlert(true)
        setMessageAlert("تم مسح العميل بنجاح")
        setLoading(false)
        setOpenModal(false)
        listUsersData();
      }
    } catch (error) {
      if (error.response) {
        setLoading(false)
        setOpenModal(false)
        setOpenAlertError(true)
        setMessageAlertError(error.response.data.message)
      }
    }
  }


  useEffect(() => {
    listUsersData();
  }, [])

  useEffect(() => {
    listUsersByFilter();
  }, [filterAction])



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event, newValue) => {
    setRowsPerPage(parseInt(newValue.toString(), 10));
    setPage(0);
  };

  const getLabelDisplayedRowsTo = () => {
    if (rows.length === -1) {
      return (page + 1) * rowsPerPage;
    }
    return rowsPerPage === -1
      ? rows.length
      : Math.min(rows.length, (page + 1) * rowsPerPage);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


  return (

    <>
      {/* Alert Meesage */}
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity="success">{messageAlert}</Alert>
      </Snackbar>

      <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
        <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
          {messageAlertError}
        </Alert>
      </Snackbar>

      {/* Modal PopUp */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only('xs')]: {
              top: 'unset',
              bottom: 0,
              left: 0,
              right: 0,
              borderRadius: 0,
              transform: 'none',
              maxWidth: 'unset',
            },
            direction: 'rtl'
          })}
        >
          <Typography id="nested-modal-title" level="h2">
            هل انت متاكد من حذف العميل ؟
          </Typography>
          <Typography id="nested-modal-description" textColor="text.tertiary">
            لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف العميل بشكل دائم وإزالة بياناته من خوادمنا.
          </Typography>
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              gap: 1,
              flexDirection: { xs: 'column', sm: 'row-reverse' },
            }}
          >
            <Button
              variant="solid"
              color="primary"
              loading={loading}
              onClick={() => confirmRemoveClient()}>
              تأكيد
            </Button>
            <Button
              variant="outlined"
              color="neutral"
              onClick={() => setOpenModal(false)}
            >
              الغاء
            </Button>
          </Box>
        </ModalDialog>
      </Modal>

      <Sheet
        variant="outlined"
        sx={{ width: '100%', boxShadow: 'sm', borderRadius: 'sm' }}
      >
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <Table
          aria-labelledby="tableTitle"
          hoverRow
          sx={{
            '--TableCell-headBackground': 'transparent',
            '--TableCell-selectedBackground': (theme) =>
              theme.vars.palette.success.softBg,
            '& thead th:nth-child(1)': {
              // width: '40px',
              textAlign: 'center'
            },
            '& tr > *:nth-child(2)': {
              width: '250px',
              textAlign: 'right'
            },
            '& tr > *:nth-child(n+1)': { textAlign: 'center' },

            // '& tr > *:nth-child(1)': { textAlign: 'center' },
            // '& tr > *:nth-child(3)': { textAlign: 'center' },
          }}
        >
          <EnhancedTableHead
            // numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <tbody>
            {stableSort(rows, getComparator(order, orderBy))
              // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <tr
                    onClick={(event) => handleClick(event, row.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    // selected={isItemSelected}
                    style={
                      isItemSelected
                        ? {
                          '--TableCell-dataBackground':
                            'var(--TableCell-selectedBackground)',
                          '--TableCell-headBackground':
                            'var(--TableCell-selectedBackground)',
                        }
                        : {}
                    }
                  >
                    {/* <th scope="row">
                      <Checkbox
                        checked={isItemSelected}
                        slotProps={{
                          input: {
                            'aria-labelledby': labelId,
                          },
                        }}
                        sx={{ verticalAlign: 'top' }}
                      />
                    </th> */}
                    <th id={labelId} scope="row">
                      {row.name ? row.name : "--"}
                    </th>
                    <td>{row.email}</td>
                    <td>{row.rest != null ? row.rest.count: 'لايوجد بيانات'}</td>
                    <td>
                      {/* {dateFormat(row.created_at, "yyyy-mm-dd'T'HH:MM:sso")} */}
                      {/* {row.created_at} */}
                      {dayjs(row.created_at).format('YYYY-MM-DD')}
                      </td>
                    <td>{row.orders_count}</td>
                    <td onClick={(e) => removeClient(e, row.id)} >
                      <DoDisturbIcon color='error' sx={{ cursor: 'pointer' }} />
                    </td>
                  </tr>
                );
              })}
            {emptyRows > 0 && (
              <tr
                style={{
                  height: `calc(${emptyRows} * 40px)`,
                  '--TableRow-hoverBackground': 'transparent',
                }}
              >
                <td colSpan={6} aria-hidden />
              </tr>
            )}
          </tbody>

        </Table>
      </Sheet>
      {loadingData ? (
        <LinearProgress />
      ) : null}
      <Stack spacing={2} alignItems='center' mt='30px'>
        <Pagination count={countPage} page={currentPage} color="primary" sx={{ margin: 'auto', direction: 'ltr' }} onChange={handleChangePagePagintion} />
      </Stack>
    </>

  );
}